import React from 'react'
import PropTypes from 'prop-types'

const Cardbrands = ({ brands }) => {
  return (
    <div className='card-brands-icons row pt-half pt-md-1 px-half justify-content-end'>
      {brands.map(({ id, imageUrl, name }) => {
        return (
          <div className='col-2 px-half' key={id}>
            <img className='w-100' src={imageUrl} alt={name} />
          </div>
        )
      })}
    </div>
  )
}

const brandType = PropTypes.shape({
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
})

Cardbrands.propTypes = {
  brands: PropTypes.arrayOf(brandType).isRequired
}

export default Cardbrands



// WEBPACK FOOTER //
// ./src/features/CardBrands/CardBrands.js